//@flow

import { createContext } from 'react'

export const fontSizeContext = createContext
